const ORGANIZATION_TYPE_LIST = [
    'buyer_donation_service',
    'buyer_jobber',
    'buyer_recycling_service',
    'buyer_wholesaler',
    'buyer_discounter',
    'buyer_marketplace_powerseller',
    'buyer_outlet',
    'buyer_retail_chain',
    'buyer_outlet_chain',
    'buyer_retail_store',
    'buyer_second_hand_store',
    'buyer_other',
    'seller_brand',
    'seller_retail_chain',
    'seller_retail_store',
    'seller_wholesaler',
    'seller_distributor',
    'seller_other',
];
export const ORGANIZATION_TYPES = ORGANIZATION_TYPE_LIST.map(key => ({
    domain: key.split('_').shift(),
    key,
    label: `resource.organization.properties.type.options.${key}`,
}));
const RATING_LIST = [
    'rating_vip',
    'rating_a',
    'rating_b',
    'rating_c',
    'none',
];
export const ORGANIZATION_RATINGS = RATING_LIST.map(key => ({ key, label: `resource.organization.properties.rating.options.${key}` }));
